<template>
    <div>
        <section class="dashboard-area">
            <div class="dashboard_menu_area" v-if="data && currentUserData && data.id === currentUserData.id">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12">
                            <ul class="dashboard_menu">
                                <li :class="{active: stateCurrentComponent === 'profile-component' ||  stateCurrentComponent === 'volunteer-backend-profile-component'}">
                                    <a class="cursor-pointer" @click="setComponent('profile-component')">
                                        <span class="icon icon-profile"></span>
                                        Профиль
                                    </a>
                                </li>
                                <li :class="{active: stateCurrentComponent === 'dashboard-component'}">
                                    <a class="cursor-pointer" @click="setComponent('dashboard-component')">
                                        <span class="icon icon-dashboard"></span>
                                        Дашборд
                                    </a>
                                </li>
                                <li :class="{active: stateCurrentComponent === 'settings-component'}">
                                    <a class="cursor-pointer" @click="setComponent('settings-component')">
                                        <span class="icon icon-setting"></span>
                                        Настройки
                                    </a>
                                </li>
                                <li :class="{active: stateCurrentComponent === 'pets-component'}">
                                    <a class="cursor-pointer" @click="setComponent('pets-component')">
                                        <span class="icon icon-notice"></span>
                                        Обьявления
                                    </a>
                                </li>
                            </ul>
                            <!-- end /.dashboard_menu -->
                        </div>
                        <!-- end /.col-md-12 -->
                    </div>
                    <!-- end /.row -->
                </div>
                <!-- end /.container -->
            </div>
            <!-- end /.dashboard_menu_area -->
            <transition name="component-fade" mode="out-in">
                <component :is="current" :user="data"></component>
            </transition>

        </section>
    </div>
</template>

<script>

import {mapGetters, mapMutations} from 'vuex';

import Profile       from './UserProfile';
import DashBoard    from './UserDashboard';
import Notifications from '../../VolunteerBackendNotificationComponent';
import Settings     from './UserSettings';
import Classifieds   from './UserClassifieds';

export default {
    props: ['data'],
    name: "UserBackend",
    components: {Profile, DashBoard, Notifications, Settings, Classifieds},
    data() {
        return {}
    },

    created(){

        if(!this.stateCurrentComponent) this.setComponent('profile-component')

        if(!this.currentUserData || (+this.currentUserData.id !== +this.data.id)){
            this.setComponent('profile-component')
        }

    },

    mounted(){},

    computed: {

        ...mapGetters({
           stateCurrentComponent: 'getterProfileTab',
           stateProfileType: 'getUserProfileType'
        }),

        currentUserData() {
            return this.$store.getters.getUserData;
        },

        current() {

            let component = null;

            if(  this.currentUserData  &&  +this.currentUserData.id  ===  +this.data.id  ) {

                switch (this.stateCurrentComponent){
                    case "profile-component":
                    case "volunteer-backend-profile-component":
                        component = 'Profile'
                        break;
                    case "dashboard-component":
                        component = 'DashBoard';
                        break;
                    case "notification-component":
                    case "volunteer-backend-notification-component":
                        component = 'Notifications'
                        break;
                    case "settings-component":
                    case "volunteer-backend-settings-component":
                        component = 'Settings'
                        break;
                    case "pets-component":
                    case "volunteer-backend-pets-component":
                        component = 'Classifieds'
                        break;
                    default:
                        break;
                }


                return component


            }

            return component = 'Profile'


        }

    },
    methods: {
        ...mapMutations({
            setComponent: 'setterProfileTab',
            setProfileType: 'setUserProfileType'
        }),
    },

    watch: {

        currentUserData(){
            if(this.currentUserData && (+this.currentUserData.id === +this.data.id)){

                if( this.stateProfileType  !== 'basic' ) this.setProfileType('basic')

            }
        }

    }


}
</script>

<style lang="scss" scoped>

.component-fade-enter-active, .component-fade-leave-active {
    transition: opacity .3s ease;
}

.component-fade-enter, .component-fade-leave-to
    /* .component-fade-leave-active до версии 2.1.8 */
{
    opacity: 0;
}
</style>
